import { Route, Routes } from "react-router-dom";
import AdminLayout from "../layout/Admin/layout/AdminLayout";
import RouteWithLayout from "../layout/RouteWithLayout";
import AboutPage from "../pages/AboutPage/AboutPage";
import AnasayfaYonetimi from "../pages/Admin/AnasayfaYonetimi/AnasayfaYonetimi";
import HakkimizdaYonetimi from "../pages/Admin/HakkimizdaYonetimi/HakkimizdaYonetimi";
import PopUpYonetimi from "../pages/Admin/PopUpYonetimi/popuppage";
import IletisimYonetimi from "../pages/Admin/IletisimYonetimi/IletisimYonetimi";
import ProjeYonetimi from "../pages/Admin/ProjeYonetimi/ProjeYonetimi";
import TemaYonetimi from "../pages/Admin/TemaYonetimi/TemaYonetimi";
import WorkshopYonetimi from "../pages/Admin/WorkshopYonetimi/WorkshopYonetimi";
// import YarismaYonetimiPage from "../pages/Admin/YarismaYonetimi/yarismayonetimipage";
import ContactPage from "../pages/ContactPage/ContactPage";
import HomePage from "../pages/HomePage/Homepage";
import IzmiriBG from "../pages/IzmiriBG/IzmiriBG";
import IzmiriBGDetay from "../pages/IzmiriBGDetay/IzmiriBGDetay";
import ProjectDetailPage from "../pages/ProjectDetailPage/ProjectDetailPage";
import ProjectsPage from "../pages/ProjectsPage/ProjectsPage";
import ThemeDetailPage from "../pages/ThemeDetailPage/ThemeDetailPage";
import ThemesPage from "../pages/ThemesPage/ThemesPage";
const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<RouteWithLayout element={<HomePage />} />} />
      <Route
        path="/hakkimizda"
        element={<RouteWithLayout element={<AboutPage />} />}
      />
      <Route
        path="/temalar"
        element={<RouteWithLayout element={<ThemesPage />} />}
      />
      <Route
        path="/temaDetay/:baslik"
        element={<RouteWithLayout element={<ThemeDetailPage />} />}
      />
      <Route
        path="/projeler"
        element={<RouteWithLayout element={<ProjectsPage />} />}
      />
      <Route
        path="/projeDetay/:id"
        element={<RouteWithLayout element={<ProjectDetailPage />} />}
      />
      <Route
        path="/birlikteGuzellestirelim"
        element={<RouteWithLayout element={<IzmiriBG />} />}
      />
      <Route
        path="/birlikteGuzellestirelimDetay/:id/:_id"
        element={<RouteWithLayout element={<IzmiriBGDetay />} />}
      />
      <Route
        path="/iletisim"
        element={<RouteWithLayout element={<ContactPage />} />}
      />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLayout />} />
      <Route
        path="/admin/anasayfa"
        element={<AdminLayout element={<AnasayfaYonetimi />} />}
      />
      <Route
        path="/admin/hakkimizda"
        element={<AdminLayout element={<HakkimizdaYonetimi />} />}
      />
      <Route
        path="/admin/popupyonetimi"
        element={<AdminLayout element={<PopUpYonetimi />} />}
      />
      <Route
        path="/admin/temalar"
        element={<AdminLayout element={<TemaYonetimi />} />}
      />
      <Route
        path="/admin/projeler"
        element={<AdminLayout element={<ProjeYonetimi />} />}
      />
      <Route
        path="/admin/birlikteGuzellestirelim"
        element={<AdminLayout element={<WorkshopYonetimi />} />}
      />
       {/* <Route
        path="/admin/yarismayonetimi"
        element={<AdminLayout element={<YarismaYonetimiPage />} />}
      />  */}
      <Route
        path="/admin/iletisim"
        element={<AdminLayout element={<IletisimYonetimi />} />}
      />
    </Routes>
  );
};

export default AppRoutes;
